module.exports = __webpack_public_path__ + "media/categories-photos/23-e1b428f0.webp";